<template>
  <div class="content">
    <div v-if="step==1" style="width: 100%;height: 100%;background-color: #fff;">
      <!-- 未绑定 -->
      <div style="margin-bottom: 1.28rem;"><img src="../../assets/images/6.png" style="width: 5.3rem;padding: .33rem 0;display: block;margin: auto;"></div>
      <div class="login_input">
        <i class="icon-user"></i>
        <input type="text" placeholder="请输入账号" v-model="userName">
      </div>
      <div class="login_input">
        <i class="icon-pass"></i>
        <input type="password" placeholder="请输入密码" ref="passInput" v-model="password">
        <i class="icon-eyes" @click="eyes"></i>
      </div>
      <div style="width: 6.9rem;margin: .4rem auto;text-align: left;overflow: hidden;">
        <a href="javascript:void(0)" style="width: 100%;height: .9rem;background-color: #3B89FF;border-radius: .06rem;display: block;color: #FFFFFF;font-size: .3rem;text-align: center;text-decoration: none;line-height: .9rem;letter-spacing: 3px;" @click="submit" v-text="loadtext"></a>
      </div>
    </div>
    <div v-if="step==2" style="background-color:#fff">
      <!-- 已绑定 -->
      <img src="../../assets/images/xsblogo.png" style="width: 75px; height:75px; margin-left:40%; margin-top:50px">
      <div style="background-color: #fff;padding: .1rem .3rem;margin: .3rem 0;">
        <div style="margin: .4rem 0; width:100%; font-size:14px; background-color:#f6f6f6; height:50px; line-height:50px">
          <span style="color:#333; margin-left:15px">机构名称：</span>
          <span v-text="organizationInfo.organizationName" style="margin-left:10px; color:#666;"></span>
        </div>
        <div style="margin: .4rem 0; width:100%; font-size:14px; background-color:#f6f6f6; height:50px; line-height:50px">
          <span style="color:#333; margin-left:15px">绑定账号：</span>
          <span v-text="organizationInfo.organizationCode" style="margin-left:10px; color:#666;"></span>
        </div>

      </div>
      <a href="javascript:void(0)" style="width: 90%;height: 1.06rem;line-height: 1.06rem;text-decoration: none;color: #FF0101;font-size: .3rem;text-align: center;background-color: #fff;display: block; border:3px #f6f6f6 solid; border-radius: 6px; margin-left:5%" @click="step=1">重新绑定</a>
      <!-- <a href="javascript:void(0)" style="width: 90%;height: 1.06rem;line-height: 1.06rem;text-decoration: none;color: #fff;font-size: .3rem;text-align: center;background-color: #3B89FF;display: block;margin: .2rem 0; border-radius: 6px; margin-left:5%" @click="$router.push('/survey')">个人中心</a> -->
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { getOpenId, getOrganizationByOpenId, bandOpenId } from '../../api';
import md5 from "js-md5";
export default {
  name: 'template',
  data() {
    return {
      openId: "",
      wxConfig: {
        appid: "wx9fc68a7bac8f1258",
        url: location.href.split('#').toString()
      },
      userName: "",
      password: "",
      loadtext: "绑定",
      organizationInfo: "",
      step: 1
    }
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]); return "";
    },
    eyes() {
      this.$refs.passInput.type = this.$refs.passInput.type == 'password' ? 'text' : 'password'
    },
    getOrganizationByOpenId() {
      var that = this;
      getOrganizationByOpenId("?openId=" + that.openId).then(function (res) {
        if (res.code == 1) {
          that.organizationInfo = res.data;
          if (that.organizationInfo.id != null) {
            that.step = 2;
          }
        } else {
          that.$toast(res.message)
        }
      })
    },
    submit() {
      var that = this;
      that.loadtext = "绑定中..."
      var date = new Date().getTime().toString()
      var date1 = new Date().getTime()
      var e = md5('ylkj1@$' + md5(that.password) + 'YLKJ1@$' + date1)
      bandOpenId("?openId=" + that.openId + "&userName=" + that.userName + "&password=" + e + "&checkTime=" + Number(date)).then(function (res) {
        that.loadtext = "绑定";
        if (res.code == 1) {
          sessionStorage.setItem('token', res.data.token);
          that.getOrganizationByOpenId();
          that.$toast("绑定成功！")
        } else {
          that.$toast(res.message)
        }
      })
    }
  },
  mounted() {
    this.openId = sessionStorage.getItem('openId');
    this.getOrganizationByOpenId();
  }
}
</script>
<style type="text/css">
html,
body,
#app {
  /*background-color: #fff;*/
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
}
.login_input {
  display: block;
  width: 6.9rem;
  height: 0.84rem;
  background: rgba(246, 246, 246, 1);
  border-radius: 0.06px;
  margin: 0.4rem auto;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0.21rem 0;
}
.login_input input {
  float: left;
  display: block;
  height: 0.4rem;
  line-height: 0.4rem;
  box-sizing: border-box;
  padding-left: 0.21rem;
  width: calc(100% - 1.7rem);
  border: none;
  background-color: transparent;
  color: #333333;
  font-size: 0.3rem;
}
.login_input i {
  width: 0.8rem;
  height: 0.4rem;
  line-height: 0.4rem;
  display: block;
  float: left;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 0.26rem auto;
  vertical-align: middle;
}
.icon-user {
  background-image: url(../../assets/images/4.png);
  border-right: 1px solid #bcbcbc;
}
.icon-pass {
  background-image: url(../../assets/images/5.png);
  border-right: 1px solid #bcbcbc;
}
.icon-eyes {
  background-image: url(../../assets/images/2.png);
}
input[type="checkbox"] {
  width: 0.24rem;
  height: 0.24rem;
  vertical-align: middle;
}
label {
  font-size: 0.24rem;
  color: #666666;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/views/bind/index.vue


// WEBPACK FOOTER //
// src/views/bind/index.vue